import IconTrashSolid from '@/assets/icons/font_awesome/trash-solid.svg?react';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { use_slice_generation, use_slice_ui, use_slice_workspace } from '@/hooks/store/use_slices';
import { UTILS__graph_data } from '@/utils/UTILS__graph_data';
import { ENUM__error_type } from '@shared/asserts/ENUM__error_type';
import { assert_array_not_empty, assert_instanceof, assert_number_gt } from '@shared/asserts/utils_asserts';
import { ENUM__workspace_entity_feature } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity_feature';
import { FIELD_PRIMITIVE__seed } from '@shared/dto/generation/graph_invoke/_fields/_primitives/FIELD_PRIMITIVE__seed';
import { delete_value_from_array } from '@shared/utils/utils_array';

interface Props {
  field: FIELD_PRIMITIVE__seed;
}

export function G_BUTTON__seed_delete({ field }: Props) {
  /*
   * STORE
   */

  const { current_workspace_user } = use_slice_workspace(['current_workspace_user']);
  const { generation_current } = use_slice_generation(['generation_current']);
  const { g_general__ui_disabled } = use_slice_ui(['g_general__ui_disabled']);

  /*
   * EVENTS
   */
  async function onClick(e: React.MouseEvent) {
    e.stopPropagation();

    let field_from_graph = generation_current.tool.graph.field__get_by_id(field.meta.field_id);
    assert_instanceof(field_from_graph, FIELD_PRIMITIVE__seed);

    let value = field.get_value();

    if (!field_from_graph.get_value_range().includes(value)) return;

    //we should keep at least two seeds to delete one and keep the last one
    assert_number_gt(field_from_graph.get_value_range().length, 1, { assert_type: ENUM__error_type.GENERATON_CANT_DELETE_LAST_SEED });

    let field_new = field_from_graph.clone();
    let velue_range_new = field_new.get_value_range();

    delete_value_from_array(velue_range_new, value);
    field_new.set_value_range(velue_range_new);

    if (value == field_new.get_value()) {
      assert_array_not_empty(velue_range_new);
      let value_new = velue_range_new[0];
      field_new.set_value(value_new);
    }

    await UTILS__graph_data.update_field(generation_current.tool.graph, field_new);
  }

  /*
   * METHODS
   */

  function is_disabled(): boolean {
    return g_general__ui_disabled || field.get_value_range().length === 1;
  }

  /*
   * HTML
   */

  if (!current_workspace_user.is_feature_pertmitted(ENUM__workspace_entity_feature.ENTITY_GENERATION_UPDATE)) return null;

  return (
    <UI_PRIMITIVE__button_with_icon_animated
      variant={'no-border-on-component'}
      iconClassNameBase="text-component-item-foreground !size-2.5"
      iconClassNameHovered="!text-bar-foreground"
      size="square-3"
      Icon={IconTrashSolid}
      disabled={is_disabled()}
      {...{ onClick }}
    />
  );
}
